"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useVideoOnReady = exports.useVideoOnPlay = exports.useVideoOnPause = exports.useVideoOnEnded = void 0;

var _react = require("react");

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Leo Khramov
 */
var useVideoOnEnded = function useVideoOnEnded(callback) {
  var onVideoEvent = function onVideoEvent(event) {
    if (callback) callback(event.detail);
  };

  (0, _react.useEffect)(function () {
    document.addEventListener("trc-video-on-ended", onVideoEvent);
    return function () {
      document.removeEventListener("trc-video-on-ended", onVideoEvent);
    };
  });
};

exports.useVideoOnEnded = useVideoOnEnded;

var useVideoOnPlay = function useVideoOnPlay(callback) {
  var onVideoEvent = function onVideoEvent(event) {
    if (callback) callback(event.detail);
  };

  (0, _react.useEffect)(function () {
    document.addEventListener("trc-video-on-play", onVideoEvent);
    return function () {
      document.removeEventListener("trc-video-on-play", onVideoEvent);
    };
  });
};

exports.useVideoOnPlay = useVideoOnPlay;

var useVideoOnPause = function useVideoOnPause(callback) {
  var onVideoEvent = function onVideoEvent(event) {
    if (callback) callback(event.detail);
  };

  (0, _react.useEffect)(function () {
    document.addEventListener("trc-video-on-pause", onVideoEvent);
    return function () {
      document.removeEventListener("trc-video-on-pause", onVideoEvent);
    };
  });
};

exports.useVideoOnPause = useVideoOnPause;

var useVideoOnReady = function useVideoOnReady(callback) {
  var onVideoEvent = function onVideoEvent(event) {
    if (callback) callback(event.detail);
  };

  (0, _react.useEffect)(function () {
    document.addEventListener("trc-video-on-ready", onVideoEvent);
    return function () {
      document.removeEventListener("trc-video-on-ready", onVideoEvent);
    };
  });
};

exports.useVideoOnReady = useVideoOnReady;